import apiV2 from "api-v2";
import type {
	NotificationListPageResponse,
	UnreadCountResponse,
} from "../types/notification-centre.types";

export const getNotifications = async (
	page: number,
	unreadOnly = false
): Promise<NotificationListPageResponse> => {
	const { data } = await apiV2.get("notifications", {
		params: { page, unread: unreadOnly ? 1 : undefined },
	});
	return data;
};

export const getUnreadCount = async (): Promise<UnreadCountResponse> => {
	const { data } = await apiV2.get("notifications/unread-count");
	return data;
};

export const markNotificationRead = async (id: number): Promise<void> => {
	await apiV2.patch(`notifications/${id}/read`);
};

export const markAllNotificationsRead = async (): Promise<UnreadCountResponse> => {
	const { data } = await apiV2.post("notifications/read-all");
	return data;
};
